<script lang="ts">
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import { buildDataSelector } from "@ui-utils/actions/buildDataSelector";
    import type { Observable } from "rxjs";

    import T from "@components/T.svelte";
    import Text from "@components/Typography/Text.svelte";

    export let dataSelectorPrefix: string | undefined;
    export let steps$: Observable<readonly string[]>;
    export let namespace: TranslationNamespaces;
</script>

{#if $steps$ && $steps$.length}
    <ul
        class="gw-list-reset-default-styles"
        data-gw-selector={buildDataSelector(
            dataSelectorPrefix,
            "referral-program-steps"
        )}
    >
        {#each $steps$ as step, index (index)}
            <li>
                <Text component="p" variant="secondary" size="sm">
                    <T {namespace} translationKey={step} />
                </Text>
            </li>
        {/each}
    </ul>
{/if}
